/* *******************/
/*    HOVER MENU     */
/* *******************/
$(document).ready(function () {

    function hoverDropdownMegamenu() {
        $('.flex-fill.nav-item.dropdown.mega-dropdown').hover(function(){
            $('.subcategory.nav-link.active').removeClass('active');
            $('.tab-pane.fade.show.active').removeClass('show active');
        });
        $('.la-navbar .dropdown.mega-dropdown .subcategory.nav-link').hover(function(){
            $('.subcategory.nav-link.active').removeClass('active');
            $(this).addClass('active');
            $('.tab-pane.fade.show.active').removeClass('show active');
            const tabId = $(this).attr("data-tab-id") || $(this).attr('href');
            $(tabId).addClass('show active');
        });
    }

    hoverDropdownMegamenu();

    const desktopNavbar = $('#desktopNavbar').clone(true);
    const desktopNavbarContainer = $('#desktopNavbarContainer');
    const mobileSidenav = $('#mobileSidenav').clone(true);
    const mobileSidenavContainer = $('#mobileSidenavContainer');

    toggleOnResize();

    $( window ).resize(function() {
        toggleOnResize();
    });

    function toggleOnResize() {
        if ($(window).width() > 992) {
            // desktop
            if ($('#mobileSidenav').length > 0) $('#mobileSidenav').detach();
            if ($('#desktopNavbar').length === 0) desktopNavbar.appendTo(desktopNavbarContainer);

            hoverDropdownMegamenu();
        } else {
            // mobile
            if ($('#desktopNavbar').length > 0) $('#desktopNavbar').detach();
            if ($('#mobileSidenav').length === 0) mobileSidenavContainer.prepend(mobileSidenav);
        }
    }
});
